export default __webpack_public_path__ + "static/media/ic-embed-image.12f48c25.svg";